import { t } from '../i18n'

export const PAGE_NAME = {
  simulator: t('constants.pageName.simulator'),
  simulationResult: t('constants.pageName.simulationResult'),
  ownerData: t('constants.pageName.ownerData'),
  additionalRiskData: t('constants.pageName.additionalRiskData'),
  summaryConditions: t('constants.pageName.summaryConditions'),
  formalization: t('constants.pageName.formalization'),
  confirmation: t('constants.pageName.confirmation'),
} as const
